import { render } from "./UriRptDownloadComponent.vue?vue&type=template&id=1f38f5d4&ts=true"
import script from "./UriRptDownloadComponent.vue?vue&type=script&lang=ts"
export * from "./UriRptDownloadComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__